<template>
  <div class="common-page-main main-page department-staff-management">
    <div class="field-box scroll-cotar">
      <div class="page-top-bar cfa">
        <div class="headline lfp">
          <span>Department Staff Management</span>
        </div>
      </div>
      <div class="content-wrap">
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="page-left-wrap">
              <div class="sub-top-bar cfa">
                <div class="title lfp">Department Management</div>
                <div class="rfp">
                  <el-button size="small" type="primary" @click="showAddDepartmentPop()">Add department</el-button>
                </div>
              </div>
              <el-tree :data="tree.data" :props="tree.prop" :expand-on-click-node="false" :highlight-current="true" :default-expand-all="true" @node-click="clickmoduleTree" :render-content="renderTreeItemContent"></el-tree>
            </div>
          </el-col>
          <el-col :span="16">
            <div class="page-right-wrap">
              <div class="sub-top-bar cfa" v-if="tree.current">
                <div class="title lfp">{{tree.current.OgName}}</div>
                <div class="rfp">
                  <el-button size="small" type="primary" @click="showAddStaffPop()">Add Staff</el-button>
                </div>
              </div>
              <div class="result-table-wrap">
                <el-table :data="tableData" v-loading="table.isLoading" element-loading-text="LOADING" style="width: 100%">
                  <el-table-column prop="AuName" label="Member Name"></el-table-column>
                  <el-table-column prop="OrganizationName" label="Department"></el-table-column>
                  <el-table-column label="Roll Group">
                    <template scope="scope">
                      <el-tag type="primary" v-for="(item, idx) in scope.row._LbNamelist" :key="idx" style="margin-right:5px">{{item}}</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column label="AVAILABLE" width="140">
                    <template scope="scope">
                      <el-tag type="success" v-if="scope.row._AuIsused">AVAILABLE</el-tag>
                      <el-tag type="danger" v-else>NO AVAILABLE</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column label="OPERATE" width="110">
                    <template scope="scope">
                      <el-dropdown split-button size="small" type="primary" @command="handleTableCommand($event, scope.$index, scope.row)" @click="showUpdateStaffPop(scope.$index, scope.row)">
                        Edit
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item command="showAddPowerPop">Limit</el-dropdown-item>
                          <el-dropdown-item command="showResetPasswordPop">Reset Password</el-dropdown-item>
                          <!-- <el-dropdown-item command="disableAccount">禁用账户</el-dropdown-item>
                          <el-dropdown-item command="enableAccount">启用账户</el-dropdown-item> -->
                          <el-dropdown-item command="delStaff">delete</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 部门弹出层 -->
    <el-dialog title="Department" :visible.sync="departmentPop.show" size="tine">
      <el-form class="pop-form-wrap w400" :model="departmentPop.data" label-width="80px" ref="pageForm">
        <el-form-item label="Superior Department" prop="Id" v-if="!departmentPop.data.Id">
          <tree-select :treeData="tree.data" :treeProps="tree.prop" v-model="departmentPop.data.Id" :multiple="false" placeholder="Please Select Department" @errorCallback="showTreeError" @setSelectedId="setSelectedId">
          </tree-select>
        </el-form-item>
        <el-form-item label="Name" prop="OgName">
          <el-input v-model="departmentPop.data.OgName" auto-complete="off"></el-input>
        </el-form-item>
        <!-- <el-form-item label="Sort" prop="OgSort">
            <el-input v-model.number="departmentPop.data.OgSort" auto-complete="off"></el-input>
          </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer pop-center-btn-wrap">
        <el-button @click="departmentPop.show = false">Canel</el-button>
        <el-button type="primary" @click="addDepartment" v-if="!departmentPop.data.Id">Add</el-button>
        <el-button type="primary" @click="updateDepartment" v-else>determine</el-button>
      </div>
    </el-dialog>
    <!-- 用户弹出层 -->
    <el-dialog title="Staff" :visible.sync="staffPop.show" size="tine">
      <el-form class="pop-form-wrap w400" :model="staffPop.data" label-width="100px" ref="pageForm">
        <el-form-item label="Name" prop="AuName">
          <el-input v-model="staffPop.data.AuName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="Account" prop="AuAccount">
          <el-input v-model="staffPop.data.AuAccount" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="Post" prop="AuPost">
          <el-input v-model="staffPop.data.AuPost" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="Mobile" prop="AuMobile">
          <el-input v-model="staffPop.data.AuMobile" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="Password" prop="AuPassword" v-if="!staffPop.data.Id">
          <el-input v-model="staffPop.data.AuPassword" type="password" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="Roll Group">
          <el-checkbox-group v-model="currentLbNameList">
            <el-checkbox :label="item.LbName" v-for="(item, idx) in LabelList" :key="idx"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer pop-center-btn-wrap">
        <el-button @click="staffPop.show = false">Canel</el-button>
        <el-button type="primary" @click="addStaff" v-if="!staffPop.data.Id">Add</el-button>
        <el-button type="primary" @click="updateStaff" v-else>determine</el-button>
      </div>
    </el-dialog>
    <!-- 权限弹出层 -->
    <el-dialog title="Give permission" :visible.sync="powerPop.show" size="tine">
      <PowerForm ref="powerForm" @updatePowerSuccess="updatePowerSuccess"></PowerForm>
    </el-dialog>
    <!-- 重置密码弹出层 -->
    <el-dialog title="ResetPassword" :visible.sync="passwordPop.show" size="tine">
      <PasswordForm ref="passwordForm" @updateSuccess="updatePasswordSuccess"></PasswordForm>
    </el-dialog>
  </div>
</template>

<script>
import tools from '@/components/common/tools'
import tree from '@/components/common/tree'

import treeSelect from '@/libcomponents/tree-select/tree'

import PowerForm from '@/components/system/PowerForm'
import PasswordForm from '@/components/system/PasswordForm'

// 部门数据对象
let departmentDataStore = tools.createDataStore({
  // FaId
  FaId: '',
  // 部门名称
  OgName: ''
})

// 用户数据对象
let staffDataStore = tools.createDataStore({
  // 部门code
  OgCode: '',
  // 用户名称
  AuName: '',
  // 用户账号
  AuAccount: '',
  // 用户职务
  AuPost: '',
  // 用户手机
  AuMobile: '',
  // 用户密码
  AuPassword: '',
  // 所属用户组
  LbCodeList: []
})

// 部门相关操作
let department = {
  methods: {
    // 获得部门数据
    getDepartmentData() {
      return tools.commonAjax.call(this, true, '/SystemManage/GetOrganizationChildRen', {
        Code: this.$store.state.user.memberInfo.OgCode
      }).then((res) => {
        let result = tree.changeLRTreeToTreeData(res.data)
        if (result.length) {
          this.tree.current = result[0]
          this.tree.data = result
          // 获得员工表格数据
          this.getStaffTableData()
        }
      })
    },
    // add部门操作
    addDepartmentDataAjax() {
      let data = tools.getModel(this.departmentPop.data)
      return tools.commonAjax.call(this, true, '/SystemManage/AddOrganization', data).then(() => {
        this.$message.success('Success!')
        // 重新获取部门数据
        this.getDepartmentData()
      })
    },
    // 修改部门操作
    updateDepartmentDataAjax() {
      let data = tools.getModel(this.departmentPop.data)
      return tools.commonAjax.call(this, true, '/SystemManage/UpdateOrganization', data).then(() => {
        this.$message.success('Fail!')
        // 重新获取部门数据
        this.getDepartmentData()
      })
    },
    // 删除部门操作
    delDepartmentDataAjax(id) {
      return tools.commonAjax.call(this, true, '/SystemManage/DelOrganization', {
        Id: id
      }).then(() => {
        this.$message.success('delete success!')
        // 重新获取部门数据
        this.getDepartmentData()
      })
    }
  }
}

// 员工相关操作
let staff = {
  methods: {
    // 获得员工表格数据
    getStaffTableData: tools.commonTableDateFetch({
      url: '/SystemManage/GetAdminUserAllInfor',
      data() {
        return {
          Code: this.tree.current.OgCode
        }
      },
      success(response) {
        let result = response.data
        this.table.data = result
      }
    }),
    // 刷新员工表格数据
    refreshStaffTableData() {
      this.getStaffTableData(this.table.currentPage)
    },
    // add员工操作
    addStaffDataAjax() {
      let data = tools.getModel(this.staffPop.data)
      data.OgCode = this.tree.current.OgCode
      data.UserLbCodeList = this.getCurrentUserLabel()
      return tools.commonAjax.call(this, true, '/SystemManage/AddAdminuser', data).then(() => {
        this.$message.success('add success!')
        // 重新获取列表数据
        this.refreshStaffTableData()
      })
    },
    // 更新员工操作
    updateStaffDataAjax() {
      let data = tools.getModel(this.staffPop.data)
      data.UserLbCodeList = this.getCurrentUserLabel()
      return tools.commonAjax.call(this, true, '/SystemManage/UpdateAdminuser', data).then(() => {
        this.$message.success('update success!')
        // 重新获取列表数据
        this.refreshStaffTableData()
        // 如果是[员工],且修改为当前用户 -> 重新获取用户信息
        if (data.AuCode === this.$store.state.user.memberInfo.AuCode) {
          this.$store.dispatch('getLoginMemberInfo', false)
        }
      })
    },
    // 删除员工操作
    delStaffDataAjax(id) {
      return tools.commonAjax.call(this, true, '/SystemManage/DeleteAdminuser', {
        Id: id
      }).then(() => {
        this.$message.success('delete success!')
        // 重新获取列表数据
        this.refreshStaffTableData()
      })
    },
    // 禁用员工操作
    disableStaffDataAjax(id) {
      return tools.commonAjax.call(this, true, '/SystemManage/SetAdminuserIsUnUsed', {
        Id: id
      }).then(() => {
        this.$message.success('operating success!')
        // 重新获取列表数据
        this.refreshStaffTableData()
      })
    },
    // 启用员工操作
    enableStaffDataAjax(id) {
      return tools.commonAjax.call(this, true, '/SystemManage/SetAdminuserIsUsed', {
        Id: id
      }).then(() => {
        this.$message.success('operating success!')
        // 重新获取列表数据
        this.refreshStaffTableData()
      })
    },
    // 获取当前员工标签
    getCurrentUserLabel() {
      let LbCodeList = []
      this.LabelList.forEach(item => {
        if (this.currentLbNameList.findIndex(el => el === item.LbName) > -1) {
          LbCodeList.push(item.LbCode)
        }
      })
      return LbCodeList.join(',')
    }
  }
}

// 角色(标签)相关操作
let label = {
  methods: {
    // 获得角色(标签)数据
    getLabelListDataAjax() {
      return tools.commonAjax.call(this, true, '/SystemManage/GetLabelList', {
        All: 1
      }).then((res) => {
        this.LabelList = res.data
      })
    },
    // 获得指定用户角色(标签)数据
    getUserLabelDataAjax(code) {
      return tools.commonAjax.call(this, true, '/SystemManage/GetLableFromAucode', {
        AuCode: code
      })
    }
  }
}

export default {
  name: 'DepartmentStaffManagement',
  mixins: [department, staff, label],
  components: {
    treeSelect, PowerForm, PasswordForm
  },
  created() {
    // 获得部门数据, 联动 -> 获取对应部门员工
    this.getDepartmentData()
    // 获得角色(标签)数据
    this.getLabelListDataAjax()
  },
  data() {
    return {
      // 部门树
      tree: {
        data: [],
        prop: {
          id: 'Id',
          label: 'OgName',
          level: 'OrganizationLayer',
          children: 'children'
        },
        current: null,
        selected: ''
      },
      // 部门弹出层
      departmentPop: {
        show: false,
        data: departmentDataStore.getDefaultData()
      },
      // 员工表格
      table: {
        isLoading: false, // 是否正在加载
        ajaxData: {}, // 额外请求参数
        data: [], // 表格当前数据
        currentPage: 1, // 当前页码
        pageSize: 15, // 每页条数
        pageTotal: 0 // 总页数
      },
      // 员工弹出层
      staffPop: {
        show: false,
        data: staffDataStore.getDefaultData()
      },
      // 权限弹出层
      powerPop: {
        show: false
      },
      // 角色(标签)列表
      LabelList: [],
      // 角色(标签)名称
      currentLbNameList: [],
      // 重置密码弹出层
      passwordPop: {
        show: false
      }
    }
  },
  computed: {
    tableData() {
      return this.table.data.map(item => {
        item._LbNamelist = item.LbNamelist ? item.LbNamelist.split(',') : []
        item._AuIsused = !!item.AuIsused
        return item
      })
    }
  },
  methods: {
    showTreeError(error) {
      this.$message.info(error.message)
    },
    setSelectedId(val) {
      this.departmentPop.data.FaId = val
    },
    // 显示add部门弹框
    showAddDepartmentPop() {
      this.departmentPop.show = true
      this.departmentPop.data = departmentDataStore.getDefaultData()
    },
    // add部门
    addDepartment() {
      this.addDepartmentDataAjax().then(() => {
        this.departmentPop.show = false
      })
    },
    // 显示修改部门弹框
    showUpdateDepartmentPop(store, item) {
      this.departmentPop.show = true
      this.departmentPop.data = tools.getModel(item)
      console.log(this.departmentPop.data)
    },
    // 修改部门
    updateDepartment() {
      this.updateDepartmentDataAjax().then(() => {
        this.departmentPop.show = false
      })
    },
    // 删除部门
    deleteDepartment(store, data) {
      this.$confirm('This will permanently delete the record', 'prompt', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Canel',
        type: 'warning'
      }).then(() => {
        this.delDepartmentDataAjax(data.Id)
      })
    },
    // 树节点点击事件
    clickmoduleTree(item) {
      let current = this.tree.current
      if (current.OgCode !== item.OgCode) {
        this.tree.current = item
        // 获得员工表格数据
        this.getStaffTableData()
      }
    },
    // 渲染树节点内容
    renderTreeItemContent(h, { node, data, store }) {
      return (
        <span>
          <span>
            <span>{node.label}</span>
          </span>
          <el-dropdown class="tree-tool-bar" on-command={command => this.handleTreeCommand(command, store, data)}>
            <span class="el-dropdown-link">
              Operate<i class="el-icon-caret-bottom el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="showUpdateDepartmentPop">edit</el-dropdown-item>
              <el-dropdown-item command="showAddPowerPop">Give permission</el-dropdown-item>
              <el-dropdown-item command="deleteDepartment">delete</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </span>)
    },
    // 显示add员工弹框
    showAddStaffPop() {
      this.currentLbNameList = []
      this.staffPop.show = true
      this.staffPop.data = staffDataStore.getDefaultData()
    },
    // add员工
    addStaff() {
      this.addStaffDataAjax().then(() => {
        this.staffPop.show = false
      })
    },
    // 显示修改员工弹框
    showUpdateStaffPop(idx, item) {
      this.getUserLabelDataAjax(item.AuCode).then(res => {
        this.currentLbNameList = res.data.map(el => el.LbName)
        this.staffPop.show = true
        this.staffPop.data = tools.getModel(item)
      })
    },
    // 更新员工
    updateStaff() {
      this.updateStaffDataAjax().then(() => {
        this.staffPop.show = false
      })
    },
    // 删除员工
    delStaff(idx, item) {
      this.$confirm('This will permanently delete the record', 'prompt', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Canel',
        type: 'warning'
      }).then(() => {
        this.delStaffDataAjax(item.Id)
      })
    },
    // 显示重置密码弹出层
    showResetPasswordPop(idx, item) {
      this.passwordPop.show = true
      this.$nextTick(function() {
        this.$refs.passwordForm.setValue({
          Id: item.Id
        })
      })
    },
    // 重置密码成功
    updatePasswordSuccess() {
      this.passwordPop.show = false
    },
    // 显示add权限弹出层
    showAddPowerPop(type, code) {
      if (this.$refs.powerForm) {
        this.$refs.powerForm.getDefaultData(type, code).then(() => {
          this.powerPop.show = true
        })
      } else {
        this.powerPop.show = true
        this.$nextTick(function() {
          this.$refs.powerForm.getDefaultData(type, code, false)
        })
      }
    },
    // 权限修改成功
    updatePowerSuccess() {
      this.powerPop.show = false
    },
    // 树工具栏命令事件
    handleTreeCommand(command, store, data) {
      if (command === 'showAddPowerPop') {
        // 0 代表部门
        this[command](0, data.OgCode)
      } else {
        this[command](store, data)
      }
    },
    // 表格工具栏命令事件
    handleTableCommand(command, idx, item) {
      if (command === 'showAddPowerPop') {
        // 1 代表用户
        this[command](1, item.AuCode)
      } else {
        this[command](idx, item)
      }
    },
    // 页码点击事件
    handleTableCurrentChange(val) {
      this.getStaffTableData(val)
    }
  }
}
</script>

<style lang="scss">
@import '~@/style/config';
.department-staff-management {
  .tree-tool-bar {
    float: right;
    margin-right: 10px;
    color: $c_xjy_4;
    .el-dropdown-link {
      font-size: 12px;
      line-height: 1em;
    }
  }
}
</style>



// WEBPACK FOOTER //
// DepartmentStaffManagement.vue?4faf8919